import { ShieldCheck } from "lucide-react";

const TrustBlock = ({ title = "Built carefully with parents", children, testId }) => {
    return (
        <div
            data-testid={testId}
            className="bg-brand-skyBlue/[0.12] rounded-3xl p-7 sm:p-9 border border-brand-skyBlue/20"
        >
            <div className="flex items-start gap-4">
                <div className="shrink-0 h-11 w-11 rounded-2xl bg-white inline-flex items-center justify-center shadow-soft">
                    <ShieldCheck size={20} strokeWidth={1.75} className="text-brand-navy" />
                </div>
                <div>
                    <h3 className="font-heading text-xl font-semibold text-brand-navy mb-2">
                        {title}
                    </h3>
                    <div className="body-prose">{children}</div>
                </div>
            </div>
        </div>
    );
};

export default TrustBlock;
